import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode, Thumbs, EffectFade, EffectCube, Autoplay } from 'swiper/modules';




  const gallery = new Swiper(".slider-gallery", {
	modules: [Navigation, Pagination, EffectFade, EffectCube, Autoplay],


	slidesPerView: 1,
	loop: true,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	speed: 2000,
	effect: 'fade',

	pagination: {
        el: '.swiper-pagination',
    },
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},

  });
